<template>
  <v-bottom-nav class="" :value="true" color="transparent">
    <v-btn color="teal" v-for="(menu, index) in menus" flat :to="menu.url" :key="index" exact>
      <span>{{menu.text}}</span>
      <v-icon>{{menu.icon}}</v-icon>
    </v-btn>
  </v-bottom-nav>
</template>

<script>
  export default {
    data() {
      return {
        menus: [
          { url: '/home', icon: 'home', text: 'Главная' },
          { url: '/employees', icon: 'people', text: 'Сотрудники' },
          { url: '/departments', icon: 'markunread_mailbox', text: 'Отделы' },
          { url: '/reports', icon: 'assessment', text: 'Отчеты' }
        ]
      }
    }
  }
</script>

<style scoped>
  .bt-menu {
    position: absolute;
  }
</style>
